/*
 *  カウントダウンでメッセージ表示
 **/

$(document).ready( function() {
    'use strict';

    /**
     * カウントダウンを実行
     **/
    function do_countdown() {
        $('.countdown,.countdown-content').each( function( ) {
            //各時刻を取得
            var now_time =  new Date().getTime() / 1000 ;
            var start_time = parseInt( $(this).data('start-time') );
            var close_time = parseInt( $(this).data('close-time') );

            var message_start = $(this).find('.countdown-message');
            var message_close = $(this).find('.countdown-close-message');

            //開始時刻チェック
            if ( now_time < start_time ) {
                return;
            }

            //終了時刻チェック
            var time_diff = close_time - now_time;

            if ( time_diff < 0 ) {
                //すでに終了している場合は終了メッセージを表示
                var close_text = message_close.text();
                if(close_text === ''){
                    $(this).fadeOut('fast').queue(function() {
                        this.remove();
                    });
                } else {
                    message_start.hide();
                    message_close.show();
                }
            } else {
                if ( time_diff > 0 ) { 
                    //残り期間を表記
                    var sec = Math.floor(time_diff);
                    var min = Math.floor( sec / 60 );
                    var hour = Math.floor( min / 60 );
                    var days = Math.floor( hour / 24 );
                    var time_text = '';
                    var time_text2 = '';

                    var massage_x = $(this).find('.countdown-message-x');
                    var message_style = $(this).find('.countdown-message-style');


                    if ( days, hour, min, sec > 0 ){
                        time_text2 = '<div class="countdown-flex"><div class="days"><span>' + days + '</span><br>日</div><div class="hour"><span>' + (hour-24*days) + '</span><br>時間</div><div class="min"><span>' + (min-60*hour) + '</span><br>分</div><div class="sec"><span>' + Math.floor(sec-60*min) + '</span><br>秒</div></div>';
                    }
                    if ( days > 1 ) {
                        time_text = (days + 1) + '日';
                    } else if ( days > 0 ) { 
                        time_text = days + '日と' + (hour-24*days) + '時間';
                    } else if ( hour > 0 ) {
                        time_text = hour + '時間' + (min-60*hour) + '分';
                    } else if ( min > 0 ) {
                        time_text = min + '分' + Math.floor(sec-60*min) + '秒';
                    } else {
                        time_text = sec + '秒';
                    }

                    massage_x.html( time_text );
                    message_style.html( time_text2 );
                }

            message_start.show();
            message_close.hide();
            }
        });
    }

    //初回実行
    //console.log('countdown start.');
    do_countdown();

    //一定時間おきに実行
    setInterval( function() { 
        do_countdown();
    }, 1000 );

});
